import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import IconButton from '../../common/IconButton';
import { BiEdit } from 'react-icons/bi';

const MyProfile = () => {
    const { user } = useSelector((state) => state.profile);
    const navigate = useNavigate();
    return (
        <div className='text-richblack-5'>
            <h1 className='text-3xl font-medium'>My Profile</h1>
            <section className='mt-10 bg-richblack-800 rounded-xl mb-7 border border-richblack-700 p-8 flex sm:flex-row gap-y-4 flex-col justify-between sm:items-center'>
                <div className='flex gap-x-4 flex-col sm:flex-row gap-y-3 items-center'>
                    <img
                        src={user?.image}
                        alt={`${user?.firstName}`}
                        className='aspect-square w-[78px] rounded-full object-cover'
                        loading='lazy'
                    />
                    <div className='flex flex-col gap-1 text-center sm:text-start font-semibold text-lg'>
                        <p className='uppercase'>{user?.firstName + " " + user?.lastName}</p>
                        <p>{user?.email}</p>
                    </div>
                </div>
                <IconButton
                    text='Edit'
                    onClick={() => { navigate('/dashboard/settings'); }}
                    customClasses={'flex items-center bg-yellow-50 mx-auto sm:mx-0 cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-richblack-900'}
                >
                    <BiEdit />
                </IconButton>
            </section>
            <section className='my-7 bg-richblack-800 rounded-xl border border-richblack-700 p-8 flex sm:flex-row flex-col gap-y-6'>
                <div className='flex flex-col justify-center gap-y-6 w-full'>
                    <div className='flex justify-between'>
                        <p className='flex flex-col gap-1 font-semibold text-lg'>About</p>
                    </div>
                    <div>
                        <p className='text-richblack-300'>{user?.additionalDetails?.about ?? 'Write something about yourself'}</p>
                    </div>
                    <div>
                        <p>Account Type: {user?.accountType ?? ''}</p>
                    </div>
                </div>
                <IconButton text='Edit' onClick={() => { navigate('/dashboard/settings') }}
                    customClasses={'flex items-center mx-auto bg-yellow-50 mb-auto cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-richblack-900'}
                >
                    <BiEdit />
                </IconButton>
            </section>
            <section className='bg-richblack-800 rounded-xl border justify-between border-richblack-700 p-8 flex flex-col sm:flex-row'>
                <div className='flex justify-between flex-col w-full mb-4 sm:mb-0'>
                    <p className='flex flex-col font-semibold text-lg'>Personal Details</p>
                    <div className='flex flex-col lg:flex-nowrap justify-between flex-wrap gap-y-4'>
                        <div className='flex flex-col sm:flex-row gap-y-4 justify-between'>
                            <div>
                                <p className='text-richblack-300 text-sm my-2'>First Name</p>
                                <p>{user?.firstName}</p>
                            </div>
                            <div className='sm:w-[40%]'>
                                <p className='text-richblack-300 text-sm my-2'>Last Name</p>
                                <p>{user?.lastName}</p>
                            </div>
                        </div>
                        <div className='flex flex-col sm:flex-row justify-between sm:mb-5 gap-y-4'>
                            <div>
                                <p className='text-richblack-300 text-sm my-2'>Email</p>
                                <p>{user?.email}</p>
                            </div>
                            <div className='sm:w-[40%]'>
                                <p className='text-richblack-300 text-sm my-2'>Gender</p>
                                <p>{user?.additionalDetails?.gender ?? 'Add gender'}</p>
                            </div>
                        </div>
                        <div className='flex flex-col sm:flex-row sm:justify-between justify-start gap-y-4'>
                            <div>
                                <p className='text-richblack-300 text-sm my-2'>Phone Number</p>
                                <div className='flex items-center gap-x-[.15rem]'>
                                    <p>{user?.additionalDetails?.countryCode ?? '+91'}</p>
                                    <p>{user?.additionalDetails?.contactNumber ?? 'Add Contact Number'}</p>
                                </div>
                            </div>
                            <div className='sm:w-[40%]'>
                                <p className='text-richblack-300 text-sm my-2'>Date of Birth</p>
                                <p>{user?.additionalDetails?.dateOfBirth ?? 'Add Date of Birth'}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <IconButton
                    text='Edit'
                    onClick={() => {
                        navigate('/dashboard/settings')
                    }}
                    customClasses={'flex items-center mx-auto mb-auto sm:mx-0 bg-yellow-50 cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-richblack-900'}
                >
                    <BiEdit />
                </IconButton>
            </section>
        </div>
    );
}

export default MyProfile;